import $ from "jquery";
export const getButtonBackgroundColor = (id: string) =>
  $(`#button-shape-${id}`).attr("fill");
export const setButtonBackgroundColor = (id: string, value: string) =>
  $(`#button-shape-${id}`).attr("fill", `${value}`);
